import VendorSchedule from './VendorSchedule';

export default VendorSchedule;
